import React from 'react';
import { Icon } from '../style';

export function TMHappy(properties) {
  return (
    <Icon
      {...properties}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 60.95 60.95"
    >
      <defs>
        <radialGradient
          id="ac6e2b9d-d796-41a8-8692-c39b48fbebbf"
          cx="-100.2"
          cy="314.5"
          r="1"
          gradientTransform="matrix(36.76 0 0 -36.76 3718.18 11590.4)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffdf30" />
          <stop offset="1" stopColor="#ffb82e" />
        </radialGradient>
        <radialGradient
          id="e5f24e78-5aad-4c27-9043-b0473809658c"
          cx="-99.44"
          cy="312.74"
          r="1"
          gradientTransform="matrix(28.92 0 0 -28.92 2910.65 9073.73)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffe95f" />
          <stop offset="1" stopColor="#ffbb47" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="f56082e7-a871-4ffe-b02d-a8036fd2219f"
          cx="-62.57"
          cy="336.66"
          r="1"
          gradientTransform="matrix(1.34 6.17 3.11 -.68 -932.61 647.92)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7a4400" />
          <stop offset="1" stopColor="#643800" />
        </radialGradient>
        <radialGradient
          id="b1229c50-e035-49f0-b93f-ebe810de0467"
          cx="-96.86"
          cy="306.76"
          r="1"
          gradientTransform="matrix(16.79 0 0 -16.79 1666.65 5205.33)"
          xlinkHref="#f56082e7-a871-4ffe-b02d-a8036fd2219f"
        />
        <radialGradient
          id="bd902d12-4a08-414f-9746-11a2a2556a57"
          cx="-95.6"
          cy="264.18"
          r="1"
          gradientTransform="matrix(13.91 0 0 -4.21 1370.84 1172.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".25" stopColor="red" />
          <stop offset="1" stopColor="#c10000" />
        </radialGradient>
        <radialGradient
          id="b8f25784-ad13-4644-8d91-05710aec4e1b"
          cx="-100.2"
          cy="314.51"
          r="1"
          gradientTransform="matrix(36.82 0 0 -36.82 3729.6 11629.83)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#a8bbbd" />
        </radialGradient>
        <radialGradient
          id="f23b43f8-d3b2-47c7-aed1-ce54e3fab221"
          cx="-69.5"
          cy="368.63"
          r="1"
          gradientTransform="matrix(-1.34 6.17 3.11 .68 -1187.53 213.64)"
          xlinkHref="#f56082e7-a871-4ffe-b02d-a8036fd2219f"
        />
        <linearGradient
          id="b37ab0b5-c721-44c9-a186-c3aa23f17066"
          x1="27.62"
          x2="26.88"
          y1="57.97"
          y2="61.09"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#7a4400" />
        </linearGradient>
        <linearGradient
          id="b94b844a-2fef-42ee-8511-cfdfe1df22cd"
          x1="30.52"
          x2="30.52"
          y1="54.91"
          y2="48.74"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#512d00" />
        </linearGradient>
        <linearGradient
          id="af77cd2f-4535-46ca-9811-ccc297bf1f43"
          x1="61.87"
          x2="19.34"
          y1="30.09"
          y2="30.09"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset=".5" stopColor="#512d00" />
          <stop offset="1" stopColor="#3c2200" />
        </linearGradient>
        <linearGradient
          id="f98ad19b-2c64-4f9b-a03f-db7dcbbc0efb"
          x1="53.33"
          x2="54.07"
          y1="57.98"
          y2="61.1"
          xlinkHref="#b37ab0b5-c721-44c9-a186-c3aa23f17066"
        />
        <linearGradient
          id="ec251a88-bd7f-4d6f-8e6c-27a3d7f1124a"
          x1="50.43"
          x2="50.43"
          y1="54.91"
          y2="48.74"
          xlinkHref="#b94b844a-2fef-42ee-8511-cfdfe1df22cd"
        />
      </defs>
      <path
        fill="url(#ac6e2b9d-d796-41a8-8692-c39b48fbebbf)"
        d="M40.47 71A30.48 30.48 0 1 0 10 40.47 30.47 30.47 0 0 0 40.47 71Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#e5f24e78-5aad-4c27-9043-b0473809658c)"
        d="M40.47 71A30.48 30.48 0 1 0 10 40.47 30.47 30.47 0 0 0 40.47 71Z"
        opacity=".5"
        style={{ isolation: 'isolate' }}
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#b37ab0b5-c721-44c9-a186-c3aa23f17066)"
        d="M33.4 20.56c-.28-1.19-1.74-1.63-3.95-1.11a12.52 12.52 0 0 0-7.73 6.79c-.37.8.53 1 .94.41A16.46 16.46 0 0 1 32 21.27c1.54-.19 1.4-.71 1.4-.71Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#f56082e7-a871-4ffe-b02d-a8036fd2219f)"
        d="M30.52 40.36c1.83 0 3.31-3 3.31-6.62s-1.48-6.62-3.31-6.62-3.3 3-3.3 6.62 1.48 6.62 3.3 6.62Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#b94b844a-2fef-42ee-8511-cfdfe1df22cd)"
        d="M30.52 29.36c1.42 0 2.66 1.65 3.29 4.06 0-3.59-1.5-6.47-3.29-6.47s-3.24 2.88-3.28 6.47c.63-2.42 1.87-4.06 3.28-4.06Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#b1229c50-e035-49f0-b93f-ebe810de0467)"
        d="M61.06 45.63a1.15 1.15 0 0 0-.71 0 72.2 72.2 0 0 1-19.86 2.76 72.86 72.86 0 0 1-19.86-2.76 1.15 1.15 0 0 0-.71 0c-.69.29-1.8 1.34-.34 5.35 2.16 5.13 7.87 14.15 20.89 14.15S59.19 56.11 61.4 51c1.44-4 .35-5.08-.34-5.37Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#bd902d12-4a08-414f-9746-11a2a2556a57)"
        d="M40.48 63.71A20.22 20.22 0 0 0 53 59.78a30.05 30.05 0 0 0-12.52-2.48A29.73 29.73 0 0 0 28 59.81a20.42 20.42 0 0 0 12.48 3.9Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#af77cd2f-4535-46ca-9811-ccc297bf1f43)"
        d="M60.65 45.55h-.15a72.29 72.29 0 0 1-20 2.82 72.29 72.29 0 0 1-20-2.82h-.14c-.44 0-2.54.48-.74 5.44a25.6 25.6 0 0 0 4.62 7.25c-2.14-2.53.5-3.94 5.19-3.37s11.11.58 11.11.58 6.41 0 11.11-.58 7.33.84 5.19 3.37A25.6 25.6 0 0 0 61.38 51c1.8-5-.3-5.42-.73-5.45Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#b8f25784-ad13-4644-8d91-05710aec4e1b)"
        d="M57 52.52a4.18 4.18 0 0 0 3.3-3.7l.2-1.82a73.75 73.75 0 0 1-20 2.76 73.73 73.73 0 0 1-20-2.76l.17 1.78a4.2 4.2 0 0 0 3.3 3.7 77.73 77.73 0 0 0 16.55 1.76A78.4 78.4 0 0 0 57 52.52Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#f98ad19b-2c64-4f9b-a03f-db7dcbbc0efb)"
        d="M47.55 20.56c.28-1.19 1.74-1.63 4-1.11a12.52 12.52 0 0 1 7.73 6.79c.37.8-.53 1-.94.41a16.46 16.46 0 0 0-9.37-5.38c-1.56-.19-1.42-.71-1.42-.71Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#f23b43f8-d3b2-47c7-aed1-ce54e3fab221)"
        d="M50.43 40.36c1.82 0 3.3-3 3.3-6.62s-1.48-6.62-3.3-6.62-3.31 3-3.31 6.62 1.48 6.62 3.31 6.62Z"
        transform="translate(-10 -10)"
      />
      <path
        fill="url(#ec251a88-bd7f-4d6f-8e6c-27a3d7f1124a)"
        d="M50.43 29.36c-1.42 0-2.66 1.65-3.29 4.06 0-3.59 1.5-6.47 3.29-6.47s3.24 2.88 3.28 6.47c-.63-2.42-1.87-4.06-3.28-4.06Z"
        transform="translate(-10 -10)"
      />
    </Icon>
  );
}
